import { render } from "./GrattersDetailComponent.vue?vue&type=template&id=13ed5ecc&scoped=true"
import script from "./GrattersDetailComponent.vue?vue&type=script&lang=js"
export * from "./GrattersDetailComponent.vue?vue&type=script&lang=js"

import "./GrattersDetailComponent.vue?vue&type=style&index=0&id=13ed5ecc&scoped=true&lang=css"

import exportComponent from "/Users/dmitriy-pc/Projects/ds-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13ed5ecc"]])

export default __exports__